import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
import { BookOpenIcon, ClipboardListIcon, HeartIcon, MoonIcon, SparklesIcon, WalletIcon, ZapIcon, MessageCircleIcon, AlertTriangleIcon, FrownIcon, PiggyBankIcon, TrendingDownIcon, CheckCircleIcon, DownloadIcon, GiftIcon } from 'lucide-react';
export function SalesPage() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleAddToCart = () => {
    // Open checkout page
    window.open('https://pay.hotmart.com/C103397678W', '_blank');
  };
  return <div className="flex flex-col items-center w-full min-h-screen bg-cream-50 text-gray-800 font-sans" data-id="element-9">
      {/* Persuasive Header */}
      <header className="w-full bg-[#166534] py-3 px-4" data-id="element-10">
        <div className="max-w-6xl mx-auto text-center" data-id="element-11">
          <p className="text-white text-sm md:text-base font-medium" data-id="element-12">
            🔥 Descarga Inmediata - Oferta Especial solo por lanzamiento
          </p>
        </div>
      </header>

      {/* Hero Section */}
      <section className="w-full max-w-4xl mx-auto px-4 py-8 md:py-10" data-id="element-13">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-14">
          <div className="flex-1" data-id="element-15">
            <h1 className="text-3xl md:text-4xl font-bold text-green-800 mb-4" data-id="element-16">
              ¿Por qué sigues llegando sin dinero… aunque trabajas duro cada
              quincena?
            </h1>
            <p className="text-lg mb-6" data-id="element-17">
              Si estás leyendo esto, es porque estás cansada.
            </p>
            <p className="text-lg mb-6" data-id="element-18">
              Cansada de esforzarte tanto… para volver a vivir la misma historia
              cada quincena:
            </p>
            <p className="text-lg font-semibold mb-6 text-red-700" data-id="element-19">
              sin dinero
              <br data-id="element-20" />
              sin claridad
              <br data-id="element-21" />
              sin entender en qué se fue
            </p>
            <p className="text-lg mb-6" data-id="element-22">
              y repitiéndote: "ahora sí me voy a organizar"
            </p>
            <p className="text-lg mb-6" data-id="element-23">
              Pero llega otra quincena… y nada cambia.
            </p>
            <p className="text-lg mb-6" data-id="element-24">Y vuelve esa pregunta dolorosa:</p>
            <p className="text-lg font-semibold mb-6 italic" data-id="element-25">
              "¿Qué estoy haciendo mal?"
            </p>
          </div>
          <div className="flex-1 flex justify-center" data-id="element-26">
            <div className="flex flex-col items-center" data-id="element-27">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iTCy8aCM9rHEaVr6eH6PxB/451d57e3-e835-4d16-86d2-ed16e8fdb89d.png" alt="De Quincena en Rojo a Quincena en Verde" className="w-full max-w-xs shadow-lg transform hover:rotate-2 transition-transform duration-300" data-id="element-28" />
              <button onClick={scrollToPricing} className="mt-6 bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-29">
                Descubre Cómo
              </button>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-10 max-w-2xl mx-auto" data-id="element-30">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-6" data-id="element-31">
            La verdad es dura, pero también liberadora:
          </h2>
          <p className="text-xl font-bold mb-6" data-id="element-32">
            NO eres tú. NO es tu salario. NO es tu disciplina. Es que te falta
            un sistema.
          </p>
          <p className="text-lg mb-8" data-id="element-33">
            Un sistema simple. Visual. Hecho para mujeres LATINAS. Un sistema
            que por fin te ayude a controlar tu dinero… y no que tu dinero te
            controle a ti.
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="w-full bg-red-50 py-8" data-id="element-34">
        <div className="max-w-5xl mx-auto px-4" data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-bold text-red-800 mb-4 text-center" data-id="element-36">
            La verdad incómoda que nadie te dice
          </h2>
          <p className="text-lg mb-3 text-center text-gray-700" data-id="element-37">
            No es que gastes de más. No es que seas mala administrando. No es
            que seas desordenada.
          </p>
          <p className="text-lg mb-3 text-center text-gray-700" data-id="element-38">
            Lo que pasa es que estás sobreviviendo sin un mapa.
          </p>
          <p className="text-lg mb-8 text-center text-gray-700 font-medium" data-id="element-39">
            Estás cruzando tu vida financiera con los ojos vendados.
          </p>
          <p className="text-xl font-semibold mb-6 text-center text-red-800" data-id="element-40">
            Y eso te deja atrapada en:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6" data-id="element-41">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-42">
              <div className="flex flex-col items-center text-center" data-id="element-43">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-44">
                  <ZapIcon className="w-8 h-8 text-red-600" data-id="element-45" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-46">
                  Estrés constante
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-47">
                  Viviendo con ansiedad financiera cada día
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-48">
              <div className="flex flex-col items-center text-center" data-id="element-49">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-50">
                  <MessageCircleIcon className="w-8 h-8 text-red-600" data-id="element-51" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-52">
                  Discusiones por dinero
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-53">
                  Conflictos constantes que dañan tus relaciones
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-54">
              <div className="flex flex-col items-center text-center" data-id="element-55">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-56">
                  <AlertTriangleIcon className="w-8 h-8 text-red-600" data-id="element-57" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-58">
                  Miedo a emergencias
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-59">
                  Sin colchón financiero para imprevistos
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-60">
              <div className="flex flex-col items-center text-center" data-id="element-61">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-62">
                  <FrownIcon className="w-8 h-8 text-red-600" data-id="element-63" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-64">
                  Sentimiento de fracaso
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-65">
                  Sintiéndote incapaz de controlar tu dinero
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-66">
              <div className="flex flex-col items-center text-center" data-id="element-67">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-68">
                  <PiggyBankIcon className="w-8 h-8 text-red-600" data-id="element-69" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-70">
                  Cero ahorro
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-71">
                  Sin poder guardar ni un peso para el futuro
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-72">
              <div className="flex flex-col items-center text-center" data-id="element-73">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-74">
                  <TrendingDownIcon className="w-8 h-8 text-red-600" data-id="element-75" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-76">
                  "Nunca avanzo"
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-77">
                  Esa dolorosa sensación de estar estancada
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-md text-center max-w-2xl mx-auto" data-id="element-78">
            <p className="text-xl font-semibold text-gray-800" data-id="element-79">
              Eso pesa. Eso duele. Pero también se puede cambiar.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full bg-green-50 py-8" data-id="element-80">
        <div className="max-w-5xl mx-auto px-4" data-id="element-81">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-4 text-center" data-id="element-82">
            Imagina esto por un momento…
          </h2>
          <p className="text-lg mb-12 text-center text-gray-600 max-w-3xl mx-auto" data-id="element-83">
            El día que te pagan, haces algo distinto. En vez de gastar "como va
            saliendo", organizas tu dinero con un sistema visual que transforma
            tu vida financiera.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-84">
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-85">
              <div className="flex items-start gap-4" data-id="element-86">
                <div className="flex-shrink-0" data-id="element-87">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-88">
                    <WalletIcon className="w-6 h-6 text-green-600" data-id="element-89" />
                  </div>
                </div>
                <div data-id="element-90">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-91">
                    Separa tu dinero en sobres
                  </h3>
                  <p className="text-gray-600" data-id="element-92">
                    Renta y servicios, mercado, transporte, tiendita,
                    emergencias y ahorro. Cada peso tiene un nombre y un lugar
                    específico.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-93">
              <div className="flex items-start gap-4" data-id="element-94">
                <div className="flex-shrink-0" data-id="element-95">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-96">
                    <ClipboardListIcon className="w-6 h-6 text-green-600" data-id="element-97" />
                  </div>
                </div>
                <div data-id="element-98">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-99">
                    Control total de tus gastos
                  </h3>
                  <p className="text-gray-600" data-id="element-100">
                    Sistema visual que te permite ver exactamente cuánto tienes
                    para cada categoría. Sin apps complicadas, sin estrés.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-101">
              <div className="flex items-start gap-4" data-id="element-102">
                <div className="flex-shrink-0" data-id="element-103">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-104">
                    <HeartIcon className="w-6 h-6 text-green-600" data-id="element-105" />
                  </div>
                </div>
                <div data-id="element-106">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-107">
                    Gustitos sin culpa
                  </h3>
                  <p className="text-gray-600" data-id="element-108">
                    Tu sobre favorito: dinero destinado para darte gustos sin
                    sentirte mal. Porque mereces disfrutar tu dinero también.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-109">
              <div className="flex items-start gap-4" data-id="element-110">
                <div className="flex-shrink-0" data-id="element-111">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-112">
                    <SparklesIcon className="w-6 h-6 text-green-600" data-id="element-113" />
                  </div>
                </div>
                <div data-id="element-114">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-115">
                    Llega con dinero sobrando
                  </h3>
                  <p className="text-gray-600" data-id="element-116">
                    Por primera vez en tu vida, llegas a la siguiente quincena
                    con dinero disponible. Ese día recuperas tu paz financiera.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-8 text-white text-center" data-id="element-117">
            <p className="text-xl md:text-2xl font-bold mb-3" data-id="element-118">
              Cada peso tiene un nombre. Cada peso tiene un lugar. Cada peso
              tiene una misión.
            </p>
            <p className="text-lg opacity-90" data-id="element-119">
              Ese día entiendes que nunca ganaste poco… solo te faltaba un
              método.
            </p>
          </div>
        </div>
      </section>

      {/* Method Section */}
      <section className="w-full py-8" data-id="element-120">
        <div className="max-w-4xl mx-auto px-4" data-id="element-121">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-700 mb-6 text-center" data-id="element-122">
            El método del sobre LATINO que cambia vidas
          </h2>
          <p className="text-lg mb-6" data-id="element-123">
            El "cash stuffing" se volvió tendencia en Estados Unidos… pero así
            como está, no funciona en LATAM.
          </p>
          <p className="text-lg mb-6" data-id="element-124">¿Por qué?</p>
          <p className="text-lg mb-6" data-id="element-125">Porque la vida aquí es distinta.</p>
          <p className="text-lg mb-8" data-id="element-126">
            Aquí existe la tiendita. Aquí se paga en efectivo. Aquí los
            antojitos importan. Aquí el transporte cambia cada semana. Aquí las
            pequeñas fugas arruinan meses completos.
          </p>
          <p className="text-lg mb-6" data-id="element-127">Por eso nació este sistema:</p>
          <div className="bg-green-100 border-l-4 border-green-600 p-6 rounded-r-lg mb-8" data-id="element-128">
            <p className="text-xl font-bold text-green-800 mb-2" data-id="element-129">
              El Método del Sobre Latino
            </p>
            <p className="text-lg text-green-700" data-id="element-130">
              (adaptado totalmente a la vida real de las mujeres de LATAM)
            </p>
            <p className="mt-4" data-id="element-131">
              Es visual. Es práctico. Es simple. Y funciona.
            </p>
          </div>
          <div className="bg-gradient-to-r from-green-700 to-green-600 text-white p-6 rounded-lg mb-6" data-id="element-132">
            <h3 className="text-xl font-bold mb-4" data-id="element-133">
              De Quincena en Rojo a Quincena en Verde
            </h3>
            <p className="mb-4" data-id="element-134">
              La guía práctica creada para mujeres latinas que quieren dejar de
              vivir "sin dinero" y empezar a ver verde en su billetera.
            </p>
          </div>
          <div className="flex justify-center" data-id="element-135">
            <button onClick={scrollToPricing} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-136">
              Descubre como
            </button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="w-full bg-amber-50 py-8" data-id="element-137">
        <div className="max-w-5xl mx-auto px-4" data-id="element-138">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-8 text-center" data-id="element-139">
            ¿Qué vas a aprender dentro?
          </h2>
          {/* Main Benefits Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-140">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-141">
              <div className="flex gap-4" data-id="element-142">
                <div className="flex-shrink-0" data-id="element-143">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-144">
                    <BookOpenIcon className="w-6 h-6 text-green-700" data-id="element-145" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-146">
                  <div className="flex items-start gap-2 mb-2" data-id="element-147">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-148" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-149">
                      Explicaciones simples
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-150">
                    Sin tecnicismos financieros, todo explicado de forma clara y
                    práctica
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-151">
              <div className="flex gap-4" data-id="element-152">
                <div className="flex-shrink-0" data-id="element-153">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-154">
                    <WalletIcon className="w-6 h-6 text-green-700" data-id="element-155" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-156">
                  <div className="flex items-start gap-2 mb-2" data-id="element-157">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-158" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-159">
                      Método del Sobre versión LATAM
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-160">
                    Sistema adaptado a la realidad latina: tiendita, transporte
                    y gastos reales
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-161">
              <div className="flex gap-4" data-id="element-162">
                <div className="flex-shrink-0" data-id="element-163">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-164">
                    <ClipboardListIcon className="w-6 h-6 text-green-700" data-id="element-165" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-166">
                  <div className="flex items-start gap-2 mb-2" data-id="element-167">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-168" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-169">
                      Ejercicios prácticos paso a paso
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-170">
                    Actividades guiadas para implementar el método desde el día
                    1
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-171">
              <div className="flex gap-4" data-id="element-172">
                <div className="flex-shrink-0" data-id="element-173">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-174">
                    <DownloadIcon className="w-6 h-6 text-green-700" data-id="element-175" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-176">
                  <div className="flex items-start gap-2 mb-2" data-id="element-177">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-178" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-179">
                      Plantillas listas para imprimir
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-180">
                    Sobres, trackers y herramientas visuales que puedes usar de
                    inmediato
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-181">
              <div className="flex gap-4" data-id="element-182">
                <div className="flex-shrink-0" data-id="element-183">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-184">
                    <PiggyBankIcon className="w-6 h-6 text-green-700" data-id="element-185" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-186">
                  <div className="flex items-start gap-2 mb-2" data-id="element-187">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-188" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-189">
                      Reto de ahorro quincenal
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-190">
                    Desafío progresivo para construir tu colchón financiero sin
                    sufrimiento
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-191">
              <div className="flex gap-4" data-id="element-192">
                <div className="flex-shrink-0" data-id="element-193">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-194">
                    <ZapIcon className="w-6 h-6 text-green-700" data-id="element-195" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-196">
                  <div className="flex items-start gap-2 mb-2" data-id="element-197">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-198" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-199">
                      Elimina fugas invisibles
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-200">
                    Identifica y detén los gastos hormiga que te roban la
                    quincena
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-201">
              <div className="flex gap-4" data-id="element-202">
                <div className="flex-shrink-0" data-id="element-203">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-204">
                    <HeartIcon className="w-6 h-6 text-green-700" data-id="element-205" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-206">
                  <div className="flex items-start gap-2 mb-2" data-id="element-207">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-208" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-209">
                      Gustitos sin culpa
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-210">
                    Aprende a darte gustos planificados sin descontrolar tu
                    presupuesto
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-211">
              <div className="flex gap-4" data-id="element-212">
                <div className="flex-shrink-0" data-id="element-213">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-214">
                    <AlertTriangleIcon className="w-6 h-6 text-green-700" data-id="element-215" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-216">
                  <div className="flex items-start gap-2 mb-2" data-id="element-217">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-218" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-219">
                      Crea tu fondo de emergencia
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-220">
                    Construye tu colchón financiero para imprevistos sin estrés
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Simple Checkmarks */}
          <div className="bg-white rounded-xl p-6 shadow-sm mb-8" data-id="element-221">
            <div className="space-y-3" data-id="element-222">
              <div className="flex items-center gap-3" data-id="element-223">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-224" />
                <span className="text-gray-700" data-id="element-225">
                  Formato digital - descarga inmediata
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-226">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-227" />
                <span className="text-gray-700" data-id="element-228">
                  Actualizado con las últimas estrategias financieras
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-229">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-230" />
                <span className="text-gray-700" data-id="element-231">
                  Acceso de por vida y actualizaciones gratuitas
                </span>
              </div>
            </div>
          </div>
          <h3 className="text-xl font-bold text-green-800 mb-4 text-center" data-id="element-232">
            Por qué funciona tan rápido
          </h3>
          <p className="text-lg mb-6" data-id="element-233">
            Porque no te pide hacer cosas imposibles.
          </p>
          <div className="bg-white rounded-xl p-6 shadow-sm mb-6" data-id="element-234">
            <div className="space-y-2 text-gray-700" data-id="element-235">
              <p data-id="element-236">❌ No te pide dejar antojitos.</p>
              <p data-id="element-237">❌ No te pide hacer dietas financieras.</p>
              <p data-id="element-238">❌ No te pide aprender contabilidad.</p>
              <p data-id="element-239">❌ No te pide revisar cada peso de memoria.</p>
            </div>
          </div>
          <p className="text-lg mb-4 font-medium text-green-800" data-id="element-240">
            Lo que te pide es algo muchísimo más simple:
          </p>
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-600 p-6 rounded-r-lg shadow-sm" data-id="element-241">
            <div className="space-y-2" data-id="element-242">
              <p className="flex items-start gap-2" data-id="element-243">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-244" />
                <span data-id="element-245">Separar tu dinero antes de gastarlo.</span>
              </p>
              <p className="flex items-start gap-2" data-id="element-246">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-247" />
                <span data-id="element-248">Darle un propósito a cada peso.</span>
              </p>
              <p className="flex items-start gap-2" data-id="element-249">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-250" />
                <span data-id="element-251">
                  Seguir un sistema visual que no requiere esfuerzo mental.
                </span>
              </p>
            </div>
          </div>
          <p className="text-lg font-bold text-green-800 mt-6 text-center" data-id="element-252">
            Eso es todo. Y funciona.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full py-6 bg-gray-50" data-id="element-253">
        <div className="max-w-4xl mx-auto px-4" data-id="element-254">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-8 text-center" data-id="element-255">
            Preguntas frecuentes
          </h2>
          <div className="space-y-6" data-id="element-256">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-257">
              <h3 className="text-xl font-bold mb-3 text-amber-700" data-id="element-258">
                ¿Es posible ahorrar desde la próxima quincena?
              </h3>
              <p data-id="element-259">Sí. Miles de mujeres ya lo están logrando con este método.</p>
              <p className="mt-2" data-id="element-260">Y tú puedes ser la siguiente.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-261">
              <h3 className="text-xl font-bold mb-3 text-amber-700" data-id="element-262">
                "Pero, ¿y si gano poco?"
              </h3>
              <p data-id="element-263">Ese es uno de los grandes mitos del dinero.</p>
              <p className="mt-3" data-id="element-264">La verdad es esta:</p>
              <p className="mt-3 font-medium" data-id="element-265">
                No importa cuánto ganes. Importa cómo organizas lo que recibes.
              </p>
              <p className="mt-3" data-id="element-266">Ganar más sin método = gastar más.</p>
              <p data-id="element-267">Ganar lo mismo con método = control total.</p>
            </div>
          </div>
          <div className="mt-8 bg-green-100 p-6 rounded-lg border-l-4 border-green-600" data-id="element-268">
            <p className="text-lg mb-4" data-id="element-269">
              Este ebook no es un gasto. Es una decisión que cambia tu vida
              financiera.
            </p>
            <p className="text-lg" data-id="element-270">
              Te acompaña cada quincena. Te da estructura. Te da claridad. Y,
              sobre todo… te devuelve la paz.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonial/Story Section */}
      <section className="w-full py-8" data-id="element-271">
        <div className="max-w-4xl mx-auto px-4" data-id="element-272">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-6" data-id="element-273">
            Mi historia (y por qué sé exactamente cómo te sientes)
          </h2>
          <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-274">
            <p className="mb-4" data-id="element-275">
              Hace unos años, cuando empecé a cobrar por quincena, vivía igual
              que tú: estresada, agobiada y con miedo de que no me alcanzara.
            </p>
            <p className="mb-4" data-id="element-276">
              Pero un día, después de una quincena especialmente dura, revisé
              mis cuentas y algo me rompió por dentro:
            </p>
            <div className="pl-4 border-l-4 border-red-500 my-6" data-id="element-277">
              <p className="mb-2 text-red-700" data-id="element-278">
                Gané bien… pero terminé con cero.
              </p>
              <p className="mb-2 text-red-700" data-id="element-279">No sabía en qué se me fue.</p>
              <p className="mb-2 text-red-700" data-id="element-280">Me sentía fracasada.</p>
              <p className="text-red-700" data-id="element-281">
                Sentí que había perdido el control de mi propia vida.
              </p>
            </div>
            <p className="mb-4" data-id="element-282">
              Esa noche lloré en silencio. No por el dinero. Sino por sentirme
              fuera de control.
            </p>
            <p className="mb-4" data-id="element-283">
              Busqué soluciones. Probé apps. Probé cursos. Probé métodos
              complicados. Nada funcionaba.
            </p>
            <p className="mb-4" data-id="element-284">
              Hasta que descubrí el "cash stuffing". Me encantó. Pero era
              demasiado gringo. No hablaba de tiendita, antojitos, transporte ni
              efectivo. No era mi realidad.
            </p>
            <p className="mb-4" data-id="element-285">
              Así que lo adapté. Lo hice simple. Lo hice visual. Lo hice latino.
            </p>
            <p className="mb-4" data-id="element-286">
              Y en la primera quincena… ahorré por primera vez en mi vida.
            </p>
            <p className="mb-4" data-id="element-287">
              Mis amigas lo pidieron. Mis primas también. Se volvió un método.
            </p>
            <p className="text-green-700 font-medium" data-id="element-288">
              Y ahora está aquí… convertido en un ebook que ya está ayudando a
              miles de mujeres a transformar su vida financiera.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing/Purchase Section - REORGANIZED */}
      <section id="pricing-section" className="w-full py-10 bg-gradient-to-b from-white to-green-50" data-id="element-289">
        <div className="max-w-5xl mx-auto px-4" data-id="element-290">
          <div className="text-center mb-8" data-id="element-291">
            <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4" data-id="element-292">
              Obtén tu guía completa hoy
            </h2>
            <p className="text-xl text-gray-700" data-id="element-293">
              Todo lo que necesitas para transformar tu vida financiera
            </p>
          </div>

          {/* SINGLE VERTICAL CONTAINER */}
          <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl shadow-2xl overflow-hidden max-w-4xl mx-auto p-8 md:p-10 text-white" data-id="element-294">
            {/* 1. Product Image */}
            <div className="flex justify-center mb-8" data-id="element-295">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uJzzoBvEB1D6rmLCyEYcJu/Mockup_Oferta.png" alt="De Quincena en Rojo a Quincena en Verde - Ebook" className="w-full max-w-sm rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-296" />
            </div>

            {/* 2. Pricing & Title */}
            <div className="text-center mb-8" data-id="element-297">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-298">
                De Quincena en Rojo a Quincena en Verde
              </h3>
              <p className="text-green-100 mb-6 text-lg" data-id="element-299">
                Tu guía práctica para el control financiero
              </p>

              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-300">
                <span className="text-5xl font-bold text-white" data-id="element-301">$7.97</span>
                <span className="text-green-200 text-xl" data-id="element-302">USD</span>
              </div>
              <p className="text-green-200 font-medium bg-green-800/30 inline-block px-4 py-1 rounded-full" data-id="element-303">
                ✨ Precio especial de lanzamiento
              </p>
            </div>

            {/* 3. Benefits */}
            <div className="space-y-3 mb-10 max-w-lg mx-auto" data-id="element-304">
              <div className="flex items-start gap-3" data-id="element-305">
                <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-0.5" data-id="element-306" />
                <span className="text-lg" data-id="element-307">Descarga inmediata en PDF</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-308">
                <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-0.5" data-id="element-309" />
                <span className="text-lg" data-id="element-310">Plantillas listas para imprimir</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-311">
                <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-0.5" data-id="element-312" />
                <span className="text-lg" data-id="element-313">
                  Método paso a paso adaptado a LATAM
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-314">
                <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-0.5" data-id="element-315" />
                <span className="text-lg" data-id="element-316">Acceso de por vida</span>
              </div>
            </div>

            {/* 4. Bonuses Header */}
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-317">
              <GiftIcon className="w-6 h-6 text-yellow-300" data-id="element-318" />
              <h3 className="text-xl md:text-2xl font-bold text-center text-yellow-300" data-id="element-319">
                BONOS INCLUIDOS GRATIS
              </h3>
              <GiftIcon className="w-6 h-6 text-yellow-300" data-id="element-320" />
            </div>

            {/* 5. BONUS #1 - Compact Card */}
            <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-xl p-6 mb-6 text-gray-900 shadow-lg" data-id="element-321">
              <div className="flex flex-col items-center text-center" data-id="element-322">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgrL3ziu8Hs2teLBcYaiY7/Mockup_Bono2.png" alt="Guía de 30 Fugas Invisibles" className="w-full max-w-xs rounded-lg shadow-md mb-4" data-id="element-323" />
                <h4 className="text-xl font-bold text-amber-800 mb-2" data-id="element-324">
                  🎁 BONO #1
                </h4>
                <h5 className="text-lg font-bold mb-3" data-id="element-325">
                  "Guía de 30 Fugas Invisibles que te Roban la Quincena"
                </h5>
                <p className="text-gray-700 mb-4 text-sm" data-id="element-326">
                  La lupa que toda mujer necesita para descubrir en qué se está
                  yendo su quincena sin darse cuenta.
                </p>
                <div className="space-y-2 mb-4 text-left w-full max-w-md mx-auto" data-id="element-327">
                  <div className="flex items-start gap-2" data-id="element-328">
                    <CheckCircleIcon className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-329" />
                    <span className="text-sm text-gray-700" data-id="element-330">
                      Identifica 30 fugas invisibles reales
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-331">
                    <CheckCircleIcon className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-332" />
                    <span className="text-sm text-gray-700" data-id="element-333">
                      Distingue entre gasto hormiga y gustito
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-334">
                    <CheckCircleIcon className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-335" />
                    <span className="text-sm text-gray-700" data-id="element-336">
                      Detecta hábitos que multiplican deudas
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-337">
                    <CheckCircleIcon className="w-4 h-4 text-amber-600 flex-shrink-0 mt-1" data-id="element-338" />
                    <span className="text-sm text-gray-700" data-id="element-339">
                      Plan 7 días "Quita Fugas"
                    </span>
                  </div>
                </div>
                <div className="bg-white rounded-lg py-2 px-4 border border-amber-200 w-full max-w-xs" data-id="element-340">
                  <p className="text-center font-bold text-amber-700 text-sm" data-id="element-341">
                    ¡GRATIS con tu compra hoy!
                  </p>
                </div>
              </div>
            </div>

            {/* 6. BONUS #2 - Compact Card */}
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-xl p-6 mb-8 text-gray-900 shadow-lg" data-id="element-342">
              <div className="flex flex-col items-center text-center" data-id="element-343">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eUBt8WrzqELqVBp3p46p4D/Mockup_Bono2.png" alt="Sobre Extra: Fondo Por Si Las Dudas" className="w-full max-w-xs rounded-lg shadow-md mb-4" data-id="element-344" />
                <h4 className="text-xl font-bold text-green-800 mb-2" data-id="element-345">
                  🎁 BONO #2
                </h4>
                <h5 className="text-lg font-bold mb-3" data-id="element-346">
                  "Sobre Extra: Fondo 'Por Si Las Dudas'"
                </h5>
                <p className="text-gray-700 mb-4 text-sm" data-id="element-347">
                  El sobre más importante de todo tu sistema: un fondo exclusivo
                  para emergencias reales.
                </p>
                <div className="space-y-2 mb-4 text-left w-full max-w-md mx-auto" data-id="element-348">
                  <div className="flex items-start gap-2" data-id="element-349">
                    <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" data-id="element-350" />
                    <span className="text-sm text-gray-700" data-id="element-351">
                      Distingue entre antojo y emergencia
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-352">
                    <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" data-id="element-353" />
                    <span className="text-sm text-gray-700" data-id="element-354">
                      Define cuánto deberías tener
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-355">
                    <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" data-id="element-356" />
                    <span className="text-sm text-gray-700" data-id="element-357">
                      Alimenta tu fondo con micro-aportaciones
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-358">
                    <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" data-id="element-359" />
                    <span className="text-sm text-gray-700" data-id="element-360">
                      Checklist: cuándo SÍ y cuándo NO tocarlo
                    </span>
                  </div>
                </div>
                <div className="bg-white rounded-lg py-2 px-4 border border-green-200 w-full max-w-xs" data-id="element-361">
                  <p className="text-center font-bold text-green-700 text-sm" data-id="element-362">
                    ¡También GRATIS con tu compra hoy! 💚
                  </p>
                </div>
              </div>
            </div>

            {/* 7. Reinforcement Text */}
            <div className="text-center mb-6" data-id="element-363">
              <p className="text-lg text-green-100" data-id="element-364">
                <strong className="text-white" data-id="element-365">Inversión de menos de $8</strong>{' '}
                para cambiar tu relación con el dinero para siempre.
              </p>
            </div>

            {/* 8. CTA Button */}
            <button onClick={handleAddToCart} className="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-6 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 mb-4" data-id="element-366">
              <DownloadIcon className="w-6 h-6" data-id="element-367" />
              Obtener mi guía ahora
            </button>

            {/* 9. Security Text */}
            <p className="text-center text-sm text-green-200" data-id="element-368">
              🔒 Pago seguro • Descarga instantánea
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full py-8 bg-green-700 text-white" data-id="element-369">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-370">
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-371">
            El cambio comienza ahora
          </h2>
          <p className="text-lg mb-8" data-id="element-372">
            No importa cómo llegaste hoy. Lo que importa es cómo quieres llegar
            a la próxima quincena.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4 mb-8 text-center" data-id="element-373">
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-374">
              <p data-id="element-375">Con miedo…</p>
              <p className="text-green-300" data-id="element-376">o con control total.</p>
            </div>
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-377">
              <p data-id="element-378">Sin dinero…</p>
              <p className="text-green-300" data-id="element-379">o con ahorro real.</p>
            </div>
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-380">
              <p data-id="element-381">Con estrés…</p>
              <p className="text-green-300" data-id="element-382">o con tranquilidad.</p>
            </div>
          </div>
          <p className="text-lg mb-8" data-id="element-383">
            Este es tu momento. Tu punto de quiebre. Tu nueva historia
            financiera comienza aquí.
          </p>
          <CTAButton data-id="element-384" />
          <div className="mt-8 text-center" data-id="element-385">
            <p className="text-xl font-bold mb-2" data-id="element-386">
              De Quincena en Rojo a Quincena en Verde
            </p>
            <p className="text-lg" data-id="element-387">
              Tu método, tu sistema, tu nueva forma de vivir la quincena.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-6 bg-green-900 text-white text-center" data-id="element-388">
        <div className="max-w-4xl mx-auto px-4" data-id="element-389">
          <p className="text-sm text-green-200" data-id="element-390">
            © 2023 De Quincena en Rojo a Quincena en Verde. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}